module.exports = "<div id=\"firebaseui-auth-container\" class=\"auth-container\">\n</div>\n"